import { dbPut } from '../core/db.js';
import { state } from '../core/state.js';
import { $, dayKey } from '../core/text.js';

/* ══════════ Serie & Wochenziel ══════════ */
export function streakDays() {
  const days = new Set(state.log.filter((l) => l.count > 0).map((l) => l.day));
  (state.progress.frozen || []).forEach((k) => days.add(k));   // Streak-Schutz zählt als gelernt
  let n = 0;
  const d = new Date();
  if (!days.has(dayKey(d))) d.setDate(d.getDate() - 1);
  while (days.has(dayKey(d))) { n++; d.setDate(d.getDate() - 1); }
  return n;
}
export function weekDays() {
  const now = new Date();
  const monday = new Date(now); monday.setDate(now.getDate() - ((now.getDay() + 6) % 7));
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday); d.setDate(monday.getDate() + i);
    const k = dayKey(d);
    return { key: k, count: state.log.find((l) => l.day === k)?.count || 0, today: k === dayKey() };
  });
}
export function renderStreak() {
  $('#streak-days').textContent = streakDays();
  const wd = weekDays();
  const total = wd.reduce((s, d) => s + d.count, 0);
  $('#week-dots').innerHTML = wd.map((d) =>
    `<div class="week-dot ${d.count ? 'done' : ''} ${d.today ? 'today' : ''}" title="${d.key}: ${d.count}"></div>`).join('');
  $('#week-goal-lbl').textContent = `${total} / ${state.goals.weekly} diese Woche`;
}
export async function logToday(count, ms, courseId) {
  const key = dayKey();
  let entry = state.log.find((l) => l.day === key);
  if (!entry) { entry = { day: key, count: 0, ms: 0, byCourse: {} }; state.log.push(entry); }
  entry.count += count; entry.ms += ms;
  if (courseId) {
    entry.byCourse[courseId] = entry.byCourse[courseId] || { count: 0, ms: 0 };
    entry.byCourse[courseId].count += count; entry.byCourse[courseId].ms += ms;
  }
  await dbPut('log', entry);
}

